// src/components/ProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = () => {
    const token = localStorage.getItem('data');
    return !!token; 
  };

  if (!isAuthenticated()) {
    return <Navigate to="/" />;
  }

  return children;
};


export default ProtectedRoute;
